<template>
  <el-dialog
    class="dailog-tips"
    v-bind="dialogProps"
    @update:visible="$emit('update:visible', $event)"
    @closed="onClosed"
  >
    <slot />
    <template #footer>
      <el-button
        type="text"
        v-show="showCancel"
        @click="$emit('update:visible', false)"
        >{{ cancelText }}</el-button
      >
      <el-button size="small" type="primary" @click="onConfirm">{{
        submitText
      }}</el-button>
    </template>
  </el-dialog>
</template>
<script>
import { pick } from "@/utils/helpers.js";

const DIALOG_PROPS = {
  visible: Boolean,
  title: {
    type: String,
    default: ""
  },
  modalAppendToBody: {
    type: Boolean,
    default: true
  },

  appendToBody: {
    type: Boolean,
    default: false
  },

  lockScroll: {
    type: Boolean,
    default: true
  },

  closeOnClickModal: {
    type: Boolean,
    default: false
  },

  closeOnPressEscape: {
    type: Boolean,
    default: true
  },

  width: String,

  fullscreen: Boolean,

  customClass: {
    type: String,
    default: ""
  },

  top: {
    type: String,
    default: "15vh"
  },
  beforeClose: Function,
  center: {
    type: Boolean,
    default: false
  },
  destroyOnClose: Boolean,
  showCancel: {
    type: Boolean,
    default: true
  },
  cancelText: {
    type: String,
    default: "取消"
  },
  submitText: {
    type: String,
    default: "确认"
  }
};

export default {
  name: "shopDialog",
  props: {
    ...DIALOG_PROPS
  },
  computed: {
    dialogProps() {
      return pick(this, Object.keys(DIALOG_PROPS));
    }
  },
  methods: {
    onClosed() {
      this.$emit("cancelFun");
    },
    onConfirm() {
      this.$emit("submitFun");
    }
  }
};
</script>
<style lang="scss">

.dailog-tips {
  .el-dialog__title {
    font-size: 16px;
  }
  .el-dialog__body {
    padding: 20px !important;
  }
  .tips em {
    color: $color-orange;
  }
}

</style>
